import { useState } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Problem from "@/components/landing/Problem";
import Solution from "@/components/landing/Solution";
import Innovation from "@/components/landing/Innovation";
import Agents from "@/components/landing/Agents";
import RoleFlow from "@/components/landing/RoleFlow";
import MoneyMeter from "@/components/landing/MoneyMeter";
import ScanAI from "@/components/landing/ScanAI";
import Access from "@/components/landing/Access";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";
import DemoModal from "@/components/landing/DemoModal";
import { useReveal } from "@/lib/useReveal";

export default function Landing() {
    useReveal();
    const [demoOpen, setDemoOpen] = useState(false);
    const openDemo = () => setDemoOpen(true);
    const closeDemo = () => setDemoOpen(false);

    return (
        <div className="dot-grid min-h-screen w-full relative">
            {/* subtle top vignette */}
            <div className="pointer-events-none fixed inset-x-0 top-0 h-32 z-30 bg-gradient-to-b from-white via-white/70 to-transparent" />

            <Navbar onOpenDemo={openDemo} />
            <main>
                <Hero onOpenDemo={openDemo} />
                <Problem />
                <Solution />
                <Innovation />
                <Agents />
                <RoleFlow />
                <MoneyMeter />
                <ScanAI />
                <Access />
                <FinalCTA onOpenDemo={openDemo} />
            </main>
            <Footer />

            <DemoModal open={demoOpen} onClose={closeDemo} />
        </div>
    );
}
